import React from 'react'

function PopularBrandButton() {
    return (
        <>
            <a href='#' id='PopularBrandButton' type='button' 
            className="btn btn-sm btn btn-bg product-view-button popular-btn"> More View</a>
        </>
    )
}

export default PopularBrandButton;
